import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

import { useToast } from 'context/providers/ToastProvider';
import ConfirmationModal from '../facturas-emitidas/lista-facturas/ConfirmationModal';

// Importing reusable components from facturas-emitidas
import ConceptosFactura from '../facturas-emitidas/visualizacion-factura/ConceptosFactura';
import DatosFactura from '../facturas-emitidas/visualizacion-factura/DatosFactura';
import SellosDigitales from '../facturas-emitidas/visualizacion-factura/SellosDigitales';

// Importing specific components for complemento de pago
import BotonesAccionComplemento from './visualizacion-complemento/BotonesAccionComplemento';
import DocumentoRelacionado from './visualizacion-complemento/DocumentoRelacionado';
import HeaderComplementoPago from './visualizacion-complemento/HeaderComplementoPago';
import ImpuestosComplemento from './visualizacion-complemento/ImpuestosComplemento';
import InformacionPago from './visualizacion-complemento/InformacionPago';
import DocumentosRelacionados from '../facturas-emitidas/visualizacion-factura/DocumentosRelacionados';
import TablaConciliaciones from '../TablaConciliaciones';

const VisualizacionFacturasPagosEmitidos = () => {

    const { showErrorToast, showSuccessToast } = useToast();
    const navigate = useNavigate();

    const { token, setToken } = useToken();
    const { id } = useParams();

    const [receptor, setReceptor] = useState({});
    const [emisor, setEmisor] = useState({});
    const [facturaElectronica, setFacturaElectronica] = useState({});
    const [datosSellos, setDatosSellos] = useState({});
    const [conceptos, setConceptos] = useState([]);
    const [total, setTotal] = useState({});
    const [value, setValue] = useState('');
    const [documentosRelacionados, setDocumentosRelacionados] = useState([]);

    //Pagos
    const [informacionPago, setInformacionPago] = useState({});
    const [documentoRelacionado, setDocumentoRelacionado] = useState({});
    const [impuestos, setImpuestos] = useState({});

    //Modal Cancelar o Eliminar
    const [showModal, setShowModal] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);
    const [isActive, setIsActive] = useState(null)
    const [dMontoConciliado, setDMontoConciliado] = useState(0);
    const [dTotalDB, setDTotalDB] = useState(0);
    const [conciliaciones, setConciliaciones] = useState([]);

    // Utilidad para formatear números en formato mexicano con dos decimales
    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    };

    useEffect(() => {
        ObtenerXML();
    }, [id]);

    /**
   * Funcion para mostrar datos de la tabla factura
   */
    const ObtenerXML = async () => {

        var objDataSend = {};

        objDataSend.idFacturaPagoEmitido = id;

        console.log("Informacion enviada al endpoint", objDataSend)
        const response = await fetch("/api/contabilidad/centro-xml/PagosEmitidos/obtenerXMLFacturaPagoEmitida",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== informacion Factura  ====");
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                console.log(ObjDetalles, "detalles")

                setIsActive(ObjDetalles.table2[0].bIsActive)
                setDMontoConciliado(ObjDetalles.table2[0].dMontoConciliado || 0);
                setDTotalDB(ObjDetalles.table2[0].dTotal || 0);
                
                // Extraer conciliaciones
                setConciliaciones(ObjDetalles.table3 || ObjDetalles.Table2 || ObjDetalles.table1 || []);

                // Paso 2: Acceder a 'table2' y obtener el primer elemento (asumiendo que hay al menos uno)
                let vXMLString = ObjDetalles.table2[0].vXML;

                // Paso 3: Parsear 'vXML' que sigue siendo una cadena JSON
                let vXML = JSON.parse(vXMLString);
                console.log(vXML)

                let receptor = vXML.Comprobante.Receptor;
                let emisorA = vXML.Comprobante.Emisor;
                let emisor = ObjDetalles.table2[0].vRegimenFiscalEmisor;

                setEmisor({ ...emisorA, ...emisor, vRegimenFiscalEmisor: emisor });

                let comprobante = vXML.Comprobante;
                let complemento = vXML.Comprobante.Complemento.timbreFiscalDigital;
                let fechaOriginal = complemento.FechaTimbrado;

                /*** Conceptos ***/
                let productos = vXML.Comprobante.Conceptos.Concepto;
                setConceptos(productos);

                const cfdiRelacionados = vXML.Comprobante.CfdiRelacionados;
                setDocumentosRelacionados(cfdiRelacionados ? (Array.isArray(cfdiRelacionados) ? cfdiRelacionados : [cfdiRelacionados]) : []);

                /*** Timbre Fiscal Digital ***/
                const tfd = vXML.Comprobante.Complemento.timbreFiscalDigital;

                /*** Cadena Original ***/
                const cadenaOriginal = `||${tfd.version}|${tfd.UUID}|${tfd.FechaTimbrado}|${tfd.RfcProvCertif}|${tfd.SelloCFD}|${tfd.NoCertificadoSAT}||`;

                /***************/
                /*Cuenta total factura*/
                /***************/

                let total = vXML.Comprobante.Total || 0;
                let subtotal = vXML.Comprobante.SubTotal || 0;
                let tasaOCuota = vXML.Comprobante.Impuestos?.Traslados?.Traslado?.[0]?.TasaOCuota || 0;
                let descuento = vXML.Comprobante.Descuento || null;

                let traslados2 = vXML.Comprobante.Impuestos?.TotalImpuestosTrasladados || 0;
                let retenidos = vXML.Comprobante.Impuestos?.TotalImpuestosRetenidos || 0;

                /***************/
                /*TRASLADOS*/
                /***************/
                let traslados = vXML.Comprobante.Impuestos?.Traslados?.Traslado;

                let TrasladoISR = null;
                let TrasladoIVA = null;
                let tieneIvaExento = false;

                if (Array.isArray(traslados)) {
                    traslados.forEach((tras) => {
                        if (tras.TipoFactor === 'Exento' && tras.Impuesto === '002') tieneIvaExento = true;
                        switch (tras.Impuesto) {
                            case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(tras.Importe || 0); break;
                            case '002': if (tras.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(tras.Importe || 0); break;
                        }
                    });
                } else if (traslados) {
                    if (traslados.TipoFactor === 'Exento' && traslados.Impuesto === '002') tieneIvaExento = true;
                    switch (traslados.Impuesto) {
                        case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(traslados.Importe || 0); break;
                        case '002': if (traslados.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(traslados.Importe || 0); break;
                    }
                }

                /***************/
                /*RETENCIONES*/
                /***************/

                let retenciones = vXML.Comprobante.Impuestos?.Retenciones?.Retencion;

                let RetencionIVA = 0;
                let RetencionISR = 0;
                let RetencionIEPS = 0;

                if (Array.isArray(retenciones)) {
                    retenciones.forEach((ret) => {
                        switch (ret.Impuesto) {
                            case '001': RetencionISR += parseFloat(ret.Importe || 0); break;
                            case '002': RetencionIVA += parseFloat(ret.Importe || 0); break;
                            case '003': RetencionIEPS += parseFloat(ret.Importe || 0); break;
                        }
                    });
                } else if (retenciones) {
                    switch (retenciones.Impuesto) {
                        case '001': RetencionISR += parseFloat(retenciones.Importe || 0); break;
                        case '002': RetencionIVA += parseFloat(retenciones.Importe || 0); break;
                        case '003': RetencionIEPS += parseFloat(retenciones.Importe || 0); break;
                    }
                }

                // Formateo de los valores a formato con comas y puntos
                let formattedTotal = formatNumberMX(total);
                let formattedSubtotal = formatNumberMX(subtotal);
                let formattedTraslados = traslados ? formatNumberMX(traslados2) : null;
                let formattedTasaOCuota = formatNumberMX(tasaOCuota);
                let formattedDescuento = descuento > 0 ? formatNumberMX(descuento) : null;
                let formattedRetenidos = retenidos ? formatNumberMX(retenidos) : null;

                // Almacenar los valores formateados
                setTotal({
                    dTotal: formattedTotal,
                    dSubtotal: formattedSubtotal,
                    dtrasladosImpuestos: formattedTraslados,
                    TasaOCuota: formattedTasaOCuota,
                    TasaOCuotaOriginal: tasaOCuota,
                    Descuento: formattedDescuento,
                    Retenidos: formattedRetenidos,
                    RetencionIVA: RetencionIVA ? formatNumberMX(RetencionIVA) : null,
                    RetencionISR: RetencionISR ? formatNumberMX(RetencionISR) : null,
                    RetencionIEPS: RetencionIEPS ? formatNumberMX(RetencionIEPS) : null,
                    TrasladoIVA: TrasladoIVA !== null ? formatNumberMX(TrasladoIVA) : null,
                    TrasladoISR: TrasladoISR !== null ? formatNumberMX(TrasladoISR) : null,
                    tieneIvaExento: tieneIvaExento
                });

                // cuando parseas y extraes del XML:
                setFacturaElectronica({
                    TipoDeComprobante: comprobante.TipoDeComprobante === "I"
                        ? 'I - Ingreso'
                        : comprobante.TipoDeComprobante === "E"
                            ? 'E - Egreso'
                            : 'P - Pago',
                    MetodoPago: comprobante.MetodoPago,
                    FormaPago: comprobante.FormaPago,
                    Moneda: comprobante.Moneda,
                    LugarExpedicion: comprobante.LugarExpedicion,
                    Fecha: comprobante.Fecha,
                    Folio: comprobante.Folio,
                    Exportacion: comprobante.Exportacion === "01" ? '01 - No Aplica' : '',
                    CertificadoEmisor: comprobante.NoCertificado,
                    Serie: comprobante.Serie,
                    TipoDeCambio: comprobante.TipoCambio,
                    CondicionesDePago: comprobante.CondicionesDePago
                });

                /*** Receptor ***/
                setReceptor({
                    ...vXML.Comprobante.Receptor,
                    vUsoCFDI: ObjDetalles.table2[0].vUsoCfdi,
                    vRegimen: ObjDetalles.table2[0].vRegimenFiscal,
                    NumRegIdTrib: comprobante.Receptor.NumRegIdTrib,
                    ResidenciaFiscal: comprobante.Receptor.ResidenciaFiscal,
                    DomicilioFiscal: comprobante.Receptor.DomicilioFiscalReceptor
                });

                /*** Datos Sellos ***/
                setDatosSellos({
                    FechaTimbrado: fechaOriginal,
                    NoCertificadoSAT: complemento.NoCertificadoSAT,
                    RfcProvCertif: complemento.RfcProvCertif,
                    SelloCFD: complemento.SelloCFD,
                    SelloSAT: complemento.SelloSAT,
                    UUID: complemento.UUID,
                    version: complemento.version,
                    certificacionSat: cadenaOriginal
                });

                /*** QR ***/
                let last8 = complemento.SelloCFD.slice(-8);
                setValue(`https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id=${complemento.UUID}&re=${emisorA.Rfc}&rr=${receptor.Rfc}&tt=${total}&fe=${last8}`);

                /*** Pagos ***/
                let version = vXML.Comprobante.Complemento.Pagos;
                let informacionPagos = vXML.Comprobante.Complemento.Pagos.Pago;

                setInformacionPago({
                    versionPagos: version.Version || "1.0",
                    montoTotalPagos: version.Totales.MontoTotalPagos,
                    totalTrasladoBaseIVA16: version.Totales.TotalTrasladosBaseIVA16,
                    totalTrasladosImpuestoIVA16: version.Totales.TotalTrasladosImpuestoIVA16,
                    totalTrasladosBaseIVA8: version.Totales.TotalTrasladosBaseIVA8,
                    totalTrasladosImpuestoIVA8: version.Totales.TotalTrasladosImpuestoIVA8,
                    totalTrasladosBaseIVA0: version.Totales.TotalTrasladosBaseIVA0,
                    totalTrasladosImpuestoIVA0: version.Totales.TotalTrasladosImpuestoIVA0,
                    totalTrasladosBaseIVAExento: version.Totales.TotalTrasladosBaseIVAExento,
                    fechaPago: informacionPagos.FechaPago,
                    formaDePagoP: ObjDetalles.table2[0].vClave,
                    monedaP: informacionPagos.MonedaP,
                    monto: informacionPagos.Monto
                });

                let docsRelacionadosXML = vXML.Comprobante.Complemento.Pagos.Pago.DoctoRelacionado;
                let arrDocs = Array.isArray(docsRelacionadosXML) ? docsRelacionadosXML : (docsRelacionadosXML ? [docsRelacionadosXML] : []);

                let documentosMapeados = arrDocs.map(doc => {
                    let impuestosDR = [];
                    if (doc.ImpuestosDR && doc.ImpuestosDR.TrasladosDR && doc.ImpuestosDR.TrasladosDR.TrasladoDR) {
                        impuestosDR = Array.isArray(doc.ImpuestosDR.TrasladosDR.TrasladoDR)
                            ? doc.ImpuestosDR.TrasladosDR.TrasladoDR
                            : [doc.ImpuestosDR.TrasladosDR.TrasladoDR];
                    }
                    let retencionesDR = [];
                    if (doc.ImpuestosDR && doc.ImpuestosDR.RetencionesDR && doc.ImpuestosDR.RetencionesDR.RetencionDR) {
                        retencionesDR = Array.isArray(doc.ImpuestosDR.RetencionesDR.RetencionDR)
                            ? doc.ImpuestosDR.RetencionesDR.RetencionDR
                            : [doc.ImpuestosDR.RetencionesDR.RetencionDR];
                    }
                    return {
                        idDocumentoRelacionado: doc.IdDocumento || "1.0",
                        serie: doc.Serie,
                        folio: doc.Folio,
                        objetoImpDR: doc.ObjetoImpDR,
                        numParcialidad: doc.NumParcialidad,
                        monedaDocumentoRelacionado: doc.MonedaDR,
                        importeSaldoAnterior: doc.ImpSaldoAnt,
                        importePagado: doc.ImpPagado,
                        importeSaldoInsoluto: doc.ImpSaldoInsoluto,
                        impuestosDR: impuestosDR,
                        retencionesDR: retencionesDR
                    };
                });

                setDocumentoRelacionado(documentosMapeados);

                let impuestosP_Node = vXML.Comprobante.Complemento.Pagos.Pago.ImpuestosP;
                let arrTrasladosP = [];
                let arrRetencionesP = [];

                if (impuestosP_Node) {
                    if (impuestosP_Node.TrasladosP && impuestosP_Node.TrasladosP.TrasladoP) {
                        arrTrasladosP = Array.isArray(impuestosP_Node.TrasladosP.TrasladoP)
                            ? impuestosP_Node.TrasladosP.TrasladoP
                            : [impuestosP_Node.TrasladosP.TrasladoP];
                    }
                    if (impuestosP_Node.RetencionesP && impuestosP_Node.RetencionesP.RetencionP) {
                        arrRetencionesP = Array.isArray(impuestosP_Node.RetencionesP.RetencionP)
                            ? impuestosP_Node.RetencionesP.RetencionP
                            : [impuestosP_Node.RetencionesP.RetencionP];
                    }
                }

                setImpuestos({
                    trasladosP: arrTrasladosP,
                    retencionesP: arrRetencionesP
                });

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Funcion para abrir modal
    */
    const handleOpenModal = (action) => {
        setCurrentAction(action);
        setShowModal(true);
    };

    /**
    * Funcion cerrar modal
    */
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentAction(null);
    };

    /**
    * Funcion para manejar el tipo de confrmacion
    */
    const handleConfirmAction = async () => {
        try {
            if (currentAction === 'eliminar') {
                await eliminarFactura();
            } else if (currentAction === 'cancelar') {
                await cancelarFactura();
            }
        } catch (error) {
            console.error(`Error al ${currentAction} la factura:`, error);
        }
    };

    /**
    * Funcion para eliminar factura definitivamente
    */
    const eliminarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaPagoEmitido = id;

        const response = await fetch("/api/contabilidad/centro-xml/PagosEmitidos/EliminaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                navigate("/contabilidad/centro-xml/pagos-emitidos");

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Funcion para cancelar factura 
    */
    const cancelarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaPagoEmitido = id;

        const response = await fetch("/api/contabilidad/centro-xml/PagosEmitidos/CancelaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    body: JSON.stringify(objDataSend)
                },
                body: JSON.stringify(objDataSend)

            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                setIsActive(false);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    // Función para recargar la factura después de cancelar en SAT
    const refreshFactura = async () => {
        await ObtenerXML();
    };

    return (
        <>
            <Card>
                <Container className="py-4">
                    <HeaderComplementoPago
                        isActive={isActive}
                        vUUIDComplemento={datosSellos?.UUID}
                        dFechaEmision={facturaElectronica?.Fecha}
                        vRfcEmisor={emisor?.Rfc}
                        dMontoConciliado={dMontoConciliado}
                        dTotal={dTotalDB}
                    />

                    <DatosFactura
                        emisor={emisor}
                        receptor={receptor}
                        facturaElectronica={facturaElectronica}
                    />

                    <ConceptosFactura
                        conceptos={conceptos}
                        total={total}
                        facturaElectronica={facturaElectronica}
                    />

                    <InformacionPago informacionPago={informacionPago} />

                    <DocumentoRelacionado documentos={documentoRelacionado} tipoPago="emitido" />

                    <DocumentosRelacionados documentos={documentosRelacionados} tipoFactura="emitida" />

                    <ImpuestosComplemento impuestos={impuestos} />

                    <SellosDigitales
                        datosSellos={datosSellos}
                        value={value}
                    />

                    <TablaConciliaciones conciliaciones={conciliaciones} />

                    <BotonesAccionComplemento
                        isActive={isActive}
                        handleOpenModal={handleOpenModal}
                        datosSellos={datosSellos}
                        emisor={emisor}
                        receptor={receptor}
                        total={total?.dTotal || null}
                        refreshFactura={refreshFactura}
                    />
                </Container>
            </Card>

            <ConfirmationModal
                show={showModal}
                onHide={handleCloseModal}
                onConfirm={handleConfirmAction}
                action={currentAction}
                IsActive={isActive}
            />
        </>
    );
}

export default VisualizacionFacturasPagosEmitidos;